// Создание тестовой доски для инициализации
import {Board, Column, Identity, Task} from "../models/types";

export const defaultTask :Task = {
	title:"New",
	description:"",

	createdAt: new Date(),
	updatedAt: new Date(),
	deletedAt: null,

	isSynced: false,
	syncVersion: 1,

	comments: [],
	attachments: [],
	meta: {},
	order: 0,


	id:"",
	localId:"",
	serverId:null,

	columnId:"",
	boardId:"",
};

export function createDefaultBoard(): Board {
	const boardId = 'board_1';
	let counter = 0;
	const getId = ()=>{
		return 'local_' + Date.now() + (++counter);
	}
	const now = new Date;
	const createIdentity :((id:string)=> Identity) = (id:string)=>{
		if (!id) id = getId();
		return {
			id:id,
			localId: id,
			serverId:null,
			isSynced: false,
			syncVersion: 0,
			createdAt: now,
			updatedAt: now,
			deletedAt: null,
		}
	};

	const tasks: Task[] = [
		{
			...defaultTask,
			...createIdentity(getId()),
			localId: getId(),
			serverId: null,
			title: 'Ситаск - ваш персональный органайзер и доска задач, хранится у вас в телефоне или ПК. '
				+ 'Работает оффлайн без регистрации и СМС. Создайте первую задачу по кнопке внизу списка.',
			columnId: 'col_1',
		},
		{
			...defaultTask,
			...createIdentity(getId()),
			localId: getId(),
			serverId: null,
			title: 'Есть режимы списка и доски задач. Переключатель режимов отображения находится сверху.'
				+ ' Попробуйте переключить режимы.',
			description: '',
			columnId: 'col_1',
			order: 1,
		},
		{
			...defaultTask,
			...createIdentity(getId()),
			localId: getId(),
			serverId: null,
			title: 'Ситаск умеет синхронизироваться с сервером. Точнее скоро будет уметь.',
			description: 'Тогда будет доступ к задачам всех устройствах.',
			columnId: 'col_2',
			order: 2,
		},
		{
			...defaultTask,
			...createIdentity(getId()),
			localId: getId(),
			serverId: null,
			title: 'Настройка списков включается по кнопке "Настроить доску" сверху доски.',
			columnId: 'col_3',
			order: 2,
		},
		{
			...defaultTask,
			...createIdentity(getId()),
			serverId: null,
			title: 'Можно архивировать задачи, когда они больше не нужны',
			columnId: 'col_3',
			order: 2,
		},
		{
			...defaultTask,
			...createIdentity(getId()),
			id: 'task_6',
			localId: getId(),
			serverId: null,
			title: 'Выберите в броузере телефона пункт "Добавить на главный экран" для использования в качестве мобильного приложения.',
			columnId: 'col_3',
			order: 2,
		},
	].map( (task) => {
		task.id = task.localId;
		task.boardId = boardId;
		return task;
	});

	const defaultColumn : Pick<Column, 'boardId'|'updatedAt'> = {
		boardId: boardId,
		updatedAt: new Date()
	};
	const columns: Column[] = [
		{
			...defaultColumn,
			...createIdentity('col_1'),
			title: 'Планируется',
			order: 0,
		},
		{
			...defaultColumn,
			...createIdentity('col_2'),
			title: 'Выполняется',
			order: 1,
		},
		{
			...defaultColumn,
			...createIdentity('col_3'),
			title: 'Готово',
			order: 2,
		},
	];

	return {
		...createIdentity('board_1'),
		title: 'Ситаск задачи',
		columns,
		tasks,
	};
}